module.exports = __webpack_public_path__ + "img/logo.298f764e.png";